import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-top-switch',
  templateUrl: './app-top-switch.component.html',
  styleUrls: ['./app-top-switch.component.scss']
})
export class AppTopSwitchComponent implements OnInit {

  @Input() model: any;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  onChange() {
    this.notify.emit(this.model);
  }


}
